var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLargeprofileicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 119,
    viewBox: "0 0 114 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.0304 0.257812C26.3779 0.257812 0.486328 27.2722 0.486328 59.254C0.486328 91.2358 26.3779 118.25 57.0304 118.25C87.683 118.25 113.574 91.2358 113.574 59.254C113.574 27.2722 87.683 0.257812 57.0304 0.257812ZM57.0304 29.7559C66.7956 29.7559 73.9936 37.2602 73.9936 47.4548C73.9936 57.6493 66.7956 65.1536 57.0304 65.1536C47.2709 65.1536 40.0672 57.6493 40.0672 47.4548C40.0672 37.2602 47.2709 29.7559 57.0304 29.7559ZM28.159 87.407C33.231 79.6195 41.69 74.4278 51.376 74.4278H62.6848C72.3765 74.4278 80.8298 79.6195 85.9018 87.407C78.6755 95.4777 68.424 100.551 57.0304 100.551C45.6368 100.551 35.3853 95.4777 28.159 87.407Z",
    fill: "#2C5281"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeprofileicon);
export default __webpack_public_path__ + "static/media/large profileicon.fe957fcb35100625fa13385f901963bc.svg";
export { ForwardRef as ReactComponent };